<template>
	<main :data-test="$route.path">
		<header>
			<div class="relative grid min-h-495 tablet:min-h-720 tabletWide:min-h-696 desktop:min-h-618">
				<div class="tablet:mx-48 desktop:mx-56">
					<div class="pt-16 tablet:pt-24 pb-32 tablet:pb-24 px-16 tablet:px-48 desktop:px-56 max-w-375 tablet:max-w-none desktop:mx-auto desktop:max-w-1440 flex flex-col h-full space-y-24">
						<breadCrumb v-bind="pageContent.pageHeader.breadcrumb" />

						<div class=" flex-1 flex flex-col justify-end tablet:justify-center space-y-24 tablet:space-y-16 tabletWide:space-y-32">
							<h1 class="flex flex-col text-white font-bold space-y-6 tablet:space-y-12 ">
								<span class="text-20 tablet:text-24">{{ pageContent.pageHeader.titleTag }}</span>
								<span class="text-40 tablet:text-64">{{ pageContent.pageHeader.title }}</span>
							</h1>

							<p class="text-white text-18 tablet:text-22" v-html="pageContent.pageHeader.headline"></p>

							<div>
								<formItinerary theme="ghost" :showLabels="true" :branch-picker-start-code="pageContent.location.code" :branch-picker-end-code="pageContent.location.code" class="bg-white/40 rounded-GO p-16 w-full tablet:w-8/12 tabletWide:w-full desktop:w-10/12 desktop:p-24 desktopWide:w-9/12" />
							</div>
						</div>
					</div>
				</div>

				<figure class="absolute inset-0 -z-10 rounded-GO overflow-hidden tablet:ml-48 desktop:ml-56">
					<goPicture v-bind="pageContent.pageHeader.picture" :enable-placeholder="false" class="h-full" />
				</figure>

				<div class="absolute inset-0 -z-10 rounded-GO overflow-hidden tablet:ml-48 desktop:ml-56 bg-goPageHeaderGradientMobile tablet:bg-goPageHeaderGradientTablet tabletWide:bg-goPageHeaderGradientTabletWide desktop:bg-goPageHeaderGradientDesktop desktopWide:bg-goPageHeaderGradientDesktopWide"></div>
			</div>
		</header>

		<div class="py-16 tablet:py-48 desktop:py-56 space-y-56 tabletWide:space-y-112">
			<LazyHydrate when-visible>
				<layoutSection v-if="$store.state.reviews.reviews.length">
					<div class="p-16 tablet:p-0 grid grid-cols-12 items-center tablet:items-stretch tabletWide:gap-16">
						<allReviews class=" col-span-8 tablet:col-span-10 tablet:col-span-9 desktop:col-span-6"/>
						<allEndorsements class=" h-full border-black/10 border-l col-span-4 tablet:col-span-2 tablet:col-span-3 desktop:col-span-6"/>
					</div>
				</layoutSection>
			</LazyHydrate>

			<LazyHydrate when-visible>
				<layoutSection>
					<layoutPost type="wide">
						<h2 class="font-bold text-32 desktop:text-48 text-goPink" v-html="pageContent.sectionA.title" />
						<div class="text-goGrayDarker space-y-32" v-html="pageContent.sectionA.html" />
					</layoutPost>
				</layoutSection>
			</LazyHydrate>

			<layoutSection>
				<div id="googleTrends" class="p-16 tablet:p-0"></div>
			</layoutSection>

			<LazyHydrate when-visible>
				<layoutSection type="post-reversed">
					<template #main>
						<layoutPost type="center">
							<header>
								<h2 class="font-bold text-32 tablet:text-40 desktop:text-48">{{ pageContent.sectionB.title }}</h2>
							</header>

							<div class="space-y-16" v-html="pageContent.sectionB.html" />
						</layoutPost>
					</template>

					<template #aside>
						<goPicture
							class="w-full"
							v-bind="pageContent.sectionB.image"
						/>
					</template>
				</layoutSection>
			</LazyHydrate>

			<hr class="tablet:ml-48 desktop:ml-56 border-black/10" />

			<LazyHydrate when-visible>
				<layoutSection type="post">
					<template #main>
						<layoutPost type="center">
							<header>
								<h2 class="font-bold text-32 tablet:text-40 desktop:text-48">{{ pageContent.sectionC.title }}</h2>
							</header>

							<div class="space-y-16" v-html="pageContent.sectionC.html" />
						</layoutPost>
					</template>

					<template #aside>
						<goPicture
							class="w-full"
							v-bind="pageContent.sectionC.image"
						/>
					</template>
				</layoutSection>
			</LazyHydrate>

			<hr class="tablet:ml-48 desktop:ml-56 border-black/10" />

			<LazyHydrate when-visible>
				<layoutSection type="post-reversed">
					<template #main>
						<layoutPost type="center">
							<header>
								<h2 class="font-bold text-32 tablet:text-40 desktop:text-48">{{ pageContent.sectionD.title }}</h2>
							</header>

							<div class="space-y-16" v-html="pageContent.sectionD.html" />
						</layoutPost>
					</template>

					<template #aside>
						<goPicture
							class="w-full"
							v-bind="pageContent.sectionD.image"
						/>
					</template>
				</layoutSection>
			</LazyHydrate>

			<hr class="tablet:ml-48 desktop:ml-56 border-black/10" />

			<LazyHydrate when-visible>
				<layoutSection type="post">
					<template #main>
						<layoutPost type="center">
							<header>
								<h2 class="font-bold text-32 tablet:text-40 desktop:text-48">{{ pageContent.sectionE.title }}</h2>
							</header>

							<div class="space-y-16" v-html="pageContent.sectionE.html" />
						</layoutPost>
					</template>

					<template #aside>
						<goPicture
							class="w-full"
							v-bind="pageContent.sectionE.image"
						/>
					</template>
				</layoutSection>
			</LazyHydrate>

			<hr class="tablet:ml-48 desktop:ml-56 border-black/10" />

			<LazyHydrate when-visible>
				<layoutSection type="post-reversed">
					<template #main>
						<layoutPost type="center">
							<header>
								<h2 class="font-bold text-32 tablet:text-40 desktop:text-48">{{ pageContent.sectionF.title }}</h2>
							</header>

							<div class="space-y-16" v-html="pageContent.sectionF.html" />
						</layoutPost>
					</template>

					<template #aside>
						<goPicture
							class="w-full"
							v-bind="pageContent.sectionF.image"
						/>
					</template>
				</layoutSection>
			</LazyHydrate>
		</div>
	</main>
</template>

<script>
import breadCrumb from '~/components/breadCrumb.vue'
import layoutSection from '~/components/layoutSection.vue'
import layoutPost from '~/components/layoutPost.vue'
import { getPageMetaData } from '~/assets/scripts/utilities/getPageMetaData'

export default {
	components: {
		layoutSection,
		layoutPost,
		breadCrumb,
		formItinerary: () => import("~/components/formItinerary.vue"),
		allReviews: () => import(/* webpackChunkName: "allReviews" */ "~/components/allReviews.vue"),
		allEndorsements: () => import(/* webpackChunkName: "allEndorsements" */ "~/components/allEndorsements.vue"),
	},
	metaInfo() {
		return {
			title: this.pageMeta.title,
			meta: [
				{
					vmid: "description",
					name: "description",
					content: this.pageMeta.description,
				},
				{ vmid: "ogtitle", property: "og:title", content: this.pageMeta.title },
				{ vmid: "ogurl", property: "og:url", content: "https://www.gorentals.co.nz/rental-car-locations/" + this.pageContent.metaInfo.url },
			],
			link: [{ rel: "canonical", href: "https://www.gorentals.co.nz/rental-car-locations/" + this.pageContent.metaInfo.canonical }],
			script: [
				{
					type: "application/ld+json",
					json: this.pageContent.structuredData.localBusiness,
				},
				{
					type: "application/ld+json",
					json: this.pageContent.structuredData.autoRental,
				},
				{
					type: "application/ld+json",
					json: this.pageContent.structuredData.product,
				},
			],
		}
	},
	validate(context) {
		return !!context.store.getters['location/bySlug'][context.route.params.slug]
	},
	async asyncData(context) {
		const { slug } = context.route.params

		const [pageMetaData, { default: pageContent }] = await Promise.all([
			getPageMetaData(context.$strapi, `${slug}_popular-destinations`),
			import("~/static/data/locations/popularDestinations/" + slug),
			context.store.dispatch("reviews/fetchCompany"),
			context.store.dispatch("reviews/fetchBranch"),
		])

		const { title, description } = pageMetaData ?? pageContent.metaInfo
		const pageMeta = {
			title,
			description
		}

		const branchReview = context.store.getters['reviews/branchBySlug'](slug)

		pageContent.location = { ...context.store.getters['location/bySlug'][slug] }
		pageContent.structuredData.localBusiness.openingHours             = "Mo,Tu,We,Th,Fr,Sa,Su " + pageContent.location.openingTime + "-" + pageContent.location.closingTime
		pageContent.structuredData.autoRental.openingHours                = "mo-su " + pageContent.location.openingTime + "-" + pageContent.location.closingTime

		if (branchReview) {
			pageContent.structuredData.autoRental.aggregateRating.reviewCount = branchReview.reviewCount
			pageContent.structuredData.autoRental.aggregateRating.ratingValue = branchReview.ratingValue
			pageContent.structuredData.autoRental.aggregateRating.bestRating  = branchReview.bestRating
			pageContent.structuredData.product.aggregateRating.reviewCount = branchReview.reviewCount
			pageContent.structuredData.product.aggregateRating.ratingValue = branchReview.ratingValue
			pageContent.structuredData.product.aggregateRating.bestRating  = branchReview.bestRating
		}

		const showItinerary = !context.store.getters["itinerary/isEmpty"]

		return {
			pageMeta,
			pageContent,
			showItinerary,
		}
	},
	beforeMount() {
		this.initTrends()
	},
	methods: {
		initTrends() {
			const script = document.createElement('script')
			script.onload = () => {
				// eslint-disable-next-line no-undef
				trends.embed.renderExploreWidgetTo(document.getElementById("googleTrends"), ...this.pageContent.googleTrends)
			}
			script.src = "https://ssl.gstatic.com/trends_nrtr/2213_RC01/embed_loader.js"

			document.head.appendChild(script)
		},
	}
}
</script>
